import { useMemo, useRef, useState } from "react";
import { Alert, Button as AntdButton, Button, Card, Dropdown, Modal, Table, Tag } from "antd";
import { PrinterOutlined, PlusOutlined, CloseCircleOutlined, FileTextOutlined, DollarOutlined, CheckCircleOutlined, MoreOutlined, CalendarOutlined, FilePdfOutlined, FileExcelOutlined } from "@ant-design/icons";
import { useReactToPrint } from "react-to-print";

import QuittanceIndemnite from "../../../docs/QuittanceIndemnite";
import OrdreDeDepense from "../../../docs/OrdreDeDepense";
import FicheDemandeReglementSinistre from "../../../docs/FicheDemandeReglementSinistre";
import AssignCheque from "../../../components/AssignCheque";
import RemiseCheque from "../../../components/RemiseCheque";
import AnnulerCheque from "../../../components/AnnulerCheque";
import ReglementModal from "../../../components/modals/ReglementModal";
import EditDecaissementModal from "../../../components/modals/EditDecaissementModal";
import axiosInstance from "../../../../../variables/api/axiosInstance";
import { displayNumbers } from "../../../../../variables/numbersFunctions";
import { frenchDate } from "../../../../../variables/functions";
import { toast } from "react-toastify";
import { rejectDecaissement, validateDecaissement } from "../../../../../hooks/useHooks";
import { generateReglementsExcel, generateReglementsPDF } from "../../../../../hooks/useExportsSinistre";

const ReglementsTab = ({
    sinistre,
    decaissements,
    evaluationCourante,
    modalQuittance,
    setModalQuittance,
    quittance,
    setQuittance,
    modalFicheDemandeReglement,
    setModalFicheDemandeReglement,
    ficheDemandeReglement,
    setFicheDemandeReglement,
    modalAssignCheque,
    setModalAssignCheque,
    modalRemiseCheque,
    setModalRemiseCheque,
    modalAnnulerCheque,
    setModalAnnulerCheque,
    decaissement,
    setDecaissement,
    montant,
    setRefetch,
    onDecaissementUpdated,
}) => {
    const [modalOrdreDepense, setModalOrdreDepense] = useState(false);
    const [ordreDepense, setOrdreDepense] = useState({});
    const printQReference = useRef(null);
    const printFDReference = useRef(null);
    const printODReference = useRef(null);

    const handleQPrint = useReactToPrint({ content: () => printQReference.current });

    const exportQToPdf = () => {
        handleQPrint();
        setTimeout(() => {
            if (quittance?.codeId) {
                axiosInstance
                    .put(`/api/decaissement/print/${quittance.codeId}`)
                    .catch(() => { /* ignore */ });
            }
        }, 500);
    };

    const exportFDRToPdf = useReactToPrint({ content: () => printFDReference.current });
    const exportODToPdf = useReactToPrint({ content: () => printODReference.current });

    const [reglementModalOpen, setReglementModalOpen] = useState(false);
    const [editDecaissementId, setEditDecaissementId] = useState(null);
    const [editModalOpen, setEditModalOpen] = useState(false);

    const reglementControl = useMemo(
        () => ({
            open: reglementModalOpen,
            setOpen: setReglementModalOpen,
            handleSubmit: () => { },
        }),
        [reglementModalOpen]
    );
    const handleValiderDecaissement = (record) => {
        Modal.confirm({
            title: "Voulez-vous vraiment valider ce décaissement ?",
            icon: <CheckCircleOutlined style={{ color: "green", fontSize: "24px" }} />,
            width: 800,
            async onOk() {
                try {
                    console.log("Décaissement validé:", record);

                    // ⛔ attendre la fin réelle de l'appel
                    await validateDecaissement(record.codeId);

                    toast.success('Décaissement validé avec succès');

                    // ✅ reload uniquement après succès
                    window.location.reload();

                } catch (e) {
                    console.log(e);
                    toast.error('Erreur lors de la validation du décaissement');
                }
            },
            onCancel() {
                console.log("Validation annulée");
            },
        });
    };

    const handleRejeterDecaissement = (record) => {
        Modal.confirm({
            title: `${record?.etatDecaissement === "EN_ATTENTE" ? "Voulez-vous vraiment rejeter ce décaissement ?" : "Voulez-vous vraiment annuler ce reglement ?"}`,
            icon: <CloseCircleOutlined style={{ color: "darkred", fontSize: "24px" }} />,
            width: 800,
            async onOk() {
                try {
                    console.log("Décaissement rejeté:", record);
                    await rejectDecaissement(record.codeId);
                    toast.success('Décaissement rejeté avec succès');
                    window.location.reload();
                } catch (e) {
                    console.log(e);
                    toast.error('Erreur lors du rejet du décaissement');
                }
            },
            onCancel() {
                console.log("Rejet annulé");
            },
        });
    };



    const handleEditDecaissement = (item) => {
        if (!item?.codeId) {
            return;
        }
        setEditDecaissementId(item.codeId);
        setEditModalOpen(true);
    };

    const handleEditModalClose = () => {
        setEditModalOpen(false);
        setEditDecaissementId(null);
    };

    const handleDecaissementUpdated = (updatedDecaissement) => {
        const shouldRefetch =
            typeof onDecaissementUpdated === "function"
                ? onDecaissementUpdated(updatedDecaissement) !== false
                : true;

        if (!shouldRefetch) {
            return;
        }

        if (typeof setRefetch === "function") {
            setRefetch((prev) => !prev);
        } else {
            window.location.reload();
        }
    };

    const showQuittance = (item) => {
        setQuittance(item);
        setModalQuittance(true);
    };

    const showFicheDemandeReglement = (item) => {
        setFicheDemandeReglement(item);
        setModalFicheDemandeReglement(true);
    };

    const showOrdreDepense = (item) => {
        console.log("Ordre de dépense pour:", item);
        setOrdreDepense(item);
        setModalOrdreDepense(true);
    };

    // const showRemiseCheque = (item) => {
    //     setQuittance(item);
    //     setModalRemiseCheque(true);
    // };

    const handleMenuClick = (e, record) => {
        switch (e.key) {
            case "edit":
                handleEditDecaissement(record);
                break;
            case "validate":
                handleValiderDecaissement(record);
                break;
            case "reject":
                handleRejeterDecaissement(record);
                break;
            case "quittance":
                showQuittance(record);
                break;
            case "ordreDepense":
                showOrdreDepense(record);
                break;
            case "ficheDemandeReglement":
                showFicheDemandeReglement(record);
                break;
            case "assignCheque":
                setDecaissement(record);
                setModalAssignCheque(true);
                break;
            case "remiseDeCheque":
                setDecaissement(record);
                setModalRemiseCheque(true);
                break;
            case "annulerCheque":
                setDecaissement(record);
                setModalAnnulerCheque(true);
                break;
            default:
                break;
        }
    };


    const getStateColor = (state) => {
        switch (state) {
            case "VALIDE":
                return { color: "success", label: "✓ Validé" };
            case "EN_ATTENTE":
                return { color: "warning", label: "⏳ En attente" };
            case "EN_ATTENTE_D_ENCAISSEMENT":
                return { color: "processing", label: "📬 En attente d'encaissement" };
            case "ENCAISSE":
                return { color: "success", label: "✓ Encaissé" };
            case "CHEQUE_ANNULE":
                return { color: "error", label: "✗ Chèque annulé" };
            case "REJETE":
                return { color: "error", label: "✗ Rejeté" };
            default:
                return { color: "default", label: state };
        }
    };

    const getAlertConfig = () => {
        if (!evaluationCourante) {
            return {
                type: "info",
                message: "Aucune évaluation n'a encore été effectuée",
                icon: "ℹ️"
            };
        }
        if (evaluationCourante?.etatEvaluation === "EN_ATTENTE") {
            return {
                type: "warning",
                message: "L'évaluation courante est en attente de validation",
                icon: "⏳"
            };
        }
        if (evaluationCourante?.etatEvaluation === "REJETE") {
            return {
                type: "error",
                message: "L'évaluation courante a été rejetée",
                icon: "✗"
            };
        }
        return null;
    };

    const alertConfig = getAlertConfig();

    const columns = [
        {
            title: "Bénéficiaire",
            dataIndex: "beneficiaire",
            key: "beneficiaire",
            width: 250,
            render: (beneficiaire, record) => (
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <div style={{
                        width: "36px",
                        height: "36px",
                        borderRadius: "50%",
                        backgroundColor: "#4f46e5",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                        fontSize: "14px",
                        fontWeight: 600
                    }}>
                        {beneficiaire?.nom?.charAt(0) || "B"}
                    </div>
                    <div>
                        <div style={{ fontWeight: 600, color: "#1a1a1a" }}>
                            {`${beneficiaire?.nom} ${beneficiaire?.prenom || ""}`.trim()}
                            {record?.numero && (
                                <Tag style={{ margin: "4px", padding: "2px 8px", fontSize: "11px", fontWeight: 500, backgroundColor: "#f3f4f6", color: "#4b5563", border: "1px solid #e5e7eb" }}>
                                    Reg. N° {record.numero}
                                </Tag>
                            )}
                        </div>
                        {record?.numeroCheque && (
                            <div style={{ fontSize: "12px", color: "#6b7280" }}>
                                Chèque N° {record.numeroCheque} - {record.banque}
                            </div>
                        )}
                    </div>
                </div>
            ),
        },
        {
            title: "Montant TTC",
            dataIndex: "montantGlobal",
            key: "montantGlobal",
            width: 140,
            render: (montantGlobal) => (
                <div style={{ fontWeight: 600, color: "#059669" }}>
                    {displayNumbers(Math.trunc(montantGlobal))} <br />
                    <span style={{ fontSize: "11px", color: "#6b7280", fontWeight: 400 }}>FCFA</span>
                </div>
            ),
        },
        {
            title: "Montant retenu",
            dataIndex: "taxes",
            key: "taxes",
            width: 130,
            render: (taxes) => (
                <div style={{ fontWeight: 600, color: "#dc2626" }}>
                    {displayNumbers(Math.trunc(taxes || 0))} <br />
                    <span style={{ fontSize: "11px", color: "#6b7280", fontWeight: 400 }}>FCFA</span>
                </div>
            ),
        },
        {
            title: "Date",
            dataIndex: "dateReglement",
            key: "dateReglement",
            width: 160,
            render: (dateReglement) => (
                <div>
                    <div style={{ fontWeight: 500, color: "#1a1a1a", fontSize: "13px" }}>
                        <CalendarOutlined style={{ marginRight: "6px", color: "#4f46e5" }} />
                        {frenchDate(dateReglement)}
                    </div>
                </div>
            ),
        },
        {
            title: "État",
            dataIndex: "etatDecaissement",
            key: "etatDecaissement",
            width: 160,
            render: (etatDecaissement) => {
                const stateConfig = getStateColor(etatDecaissement);
                return (
                    <Tag
                        color={stateConfig.color}
                        style={{
                            padding: "6px 12px",
                            borderRadius: "6px",
                            fontSize: "12px",
                            fontWeight: 500,
                            border: "none"
                        }}
                    >
                        {stateConfig.label}
                    </Tag>
                );
            },
        },
        {
            title: "Actions",
            key: "actions",
            width: 60,
            fixed: "right",
            align: "center",
            render: (_, record) => (
                <Dropdown
                    menu={{
                        items: getMenuItems(record),
                        onClick: (e) => handleMenuClick(e, record),
                    }}
                    trigger={['click']}

                >
                    <Button
                        type="text"
                        icon={<MoreOutlined />}
                        style={{ cursor: "pointer", fontSize: "18px" }}
                    />
                </Dropdown>
            ),
        },
    ];

    const getMenuItems = (record) => {
        const etat = record?.etatDecaissement;
        const items = [];

        // Édition : uniquement avant validation
        if (etat === "EN_ATTENTE") {
            items.push({
                key: "edit",
                icon: <i className="bx bx-edit" />,
                label: "Éditer",
            });
        }

        // EN_ATTENTE → valider ou rejeter
        if (etat === "EN_ATTENTE") {
            items.push({
                key: "validate",
                icon: <CheckCircleOutlined style={{ color: "green" }} />,
                label: "Valider",
            });
            items.push({
                key: "reject",
                icon: <CloseCircleOutlined style={{ color: "red" }} />,
                label: "Rejeter",
            });
        }

        // VALIDE → assigner un chèque, imprimer documents, annuler le règlement
        if (etat === "VALIDE") {
            if (items.length) items.push({ type: "divider" });
            items.push({
                key: "assignCheque",
                icon: <DollarOutlined />,
                label: "Assigner Chèque",
            });
            items.push({
                key: "ordreDepense",
                icon: <PrinterOutlined />,
                label: "Ordre de Dépense",
            });
            items.push({
                key: "ficheDemandeReglement",
                icon: <FileTextOutlined />,
                label: "Fiche Demande",
            });
            items.push({
                key: "reject",
                icon: <CloseCircleOutlined style={{ color: "red" }} />,
                label: "Annuler le règlement",
            });
        }

        // EN_ATTENTE_D_ENCAISSEMENT → remise OU annulation du chèque + impressions
        if (etat === "EN_ATTENTE_D_ENCAISSEMENT") {
            if (items.length) items.push({ type: "divider" });
            items.push({
                key: "quittance",
                icon: <FileTextOutlined />,
                label: "Quittance",
            });
            items.push({
                key: "ordreDepense",
                icon: <PrinterOutlined />,
                label: "Ordre de Dépense",
            });
            items.push({
                key: "ficheDemandeReglement",
                icon: <FileTextOutlined />,
                label: "Fiche Demande",
            });
            items.push({
                key: "remiseDeCheque",
                icon: <CheckCircleOutlined style={{ color: "green" }} />,
                label: "Remise de chèque",
            });
            items.push({
                key: "annulerCheque",
                icon: <CloseCircleOutlined style={{ color: "red" }} />,
                label: "Annuler le chèque",
            });
        }

        // ENCAISSE → consultations + annulation du chèque
        if (etat === "ENCAISSE") {
            if (items.length) items.push({ type: "divider" });
            items.push({
                key: "quittance",
                icon: <FileTextOutlined />,
                label: "Quittance",
            });
            items.push({
                key: "ordreDepense",
                icon: <PrinterOutlined />,
                label: "Ordre de Dépense",
            });
            items.push({
                key: "ficheDemandeReglement",
                icon: <FileTextOutlined />,
                label: "Fiche Demande",
            });
            items.push({
                key: "annulerCheque",
                icon: <CloseCircleOutlined style={{ color: "red" }} />,
                label: "Annuler le chèque",
            });
        }

        // CHEQUE_ANNULE → état terminal côté chèque ; on peut éventuellement
        // réassigner un nouveau chèque (à confirmer côté backend) + consulter.
        if (etat === "CHEQUE_ANNULE") {
            if (items.length) items.push({ type: "divider" });
            items.push({
                key: "assignCheque",
                icon: <DollarOutlined />,
                label: "Réassigner un nouveau chèque",
            });
            items.push({
                key: "ordreDepense",
                icon: <PrinterOutlined />,
                label: "Ordre de Dépense",
            });
            items.push({
                key: "ficheDemandeReglement",
                icon: <FileTextOutlined />,
                label: "Fiche Demande",
            });
        }

        // REJETE → état terminal, aucune action
        // (on peut laisser le menu vide ou ne pas afficher le bouton "..." du tout)

        return items;
    };


    return (
        <div style={{ padding: "24px", backgroundColor: "#f5f7fa", minHeight: "100vh" }}>
            {/* Header Section */}
            <div style={{
                marginBottom: "24px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "16px"
            }}>
                <div>
                    <h2 style={{ margin: 0, fontSize: "24px", fontWeight: 600, color: "#1a1a1a" }}>
                        Règlements
                    </h2>
                    <p style={{ margin: "4px 0 0 0", color: "#6b7280", fontSize: "14px" }}>
                        {decaissements?.length || 0} règlement(s) enregistré(s)
                    </p>
                </div>
                <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                    {/* Boutons d'export — visibles uniquement s'il y a des données */}
                    {decaissements?.length > 0 && (
                        <>
                            <Button
                                icon={<FilePdfOutlined />}
                                onClick={() => generateReglementsPDF(decaissements, sinistre)}
                                style={{
                                    height: "44px",
                                    borderRadius: "8px",
                                    fontWeight: 500,
                                    borderColor: "#dc2626",
                                    color: "#dc2626",
                                }}
                            >
                                Exporter PDF
                            </Button>
                            <Button
                                icon={<FileExcelOutlined />}
                                onClick={() => generateReglementsExcel(decaissements, sinistre)}
                                style={{
                                    height: "44px",
                                    borderRadius: "8px",
                                    fontWeight: 500,
                                    borderColor: "#059669",
                                    color: "#059669",
                                }}
                            >
                                Exporter Excel
                            </Button>
                        </>
                    )}
                    {evaluationCourante?.etatEvaluation === "VALIDE" && (
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            size="large"
                            onClick={() => setReglementModalOpen(true)}
                            style={{
                                backgroundColor: '#242166',
                                borderColor: '#242166',
                                height: "44px",
                                borderRadius: "8px",
                                fontWeight: 500,
                                boxShadow: "0 2px 8px rgba(79, 70, 229, 0.3)"
                            }}
                        >
                            Nouveau Règlement
                        </Button>
                    )}
                </div>
            </div>

            {/* Alert Section */}
            {alertConfig && (
                <div style={{ marginBottom: "20px" }}>
                    <Alert
                        message={alertConfig.message}
                        type={alertConfig.type}
                        showIcon
                        style={{
                            borderRadius: "8px",
                            border: "none",
                            fontSize: "14px"
                        }}
                    />
                </div>
            )}

            {/* Table or Empty State */}
            {decaissements?.length ? (
                <Card
                    style={{
                        borderRadius: "12px",
                        border: "1px solid #e5e7eb",
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
                        overflow: "hidden"
                    }}
                >
                    <Table
                        dataSource={decaissements}
                        columns={columns}
                        rowKey="codeId"
                        pagination={{
                            pageSize: 10,
                            showSizeChanger: true,
                            showQuickJumper: true,
                            total: decaissements.length,
                            showTotal: (total) => `Total: ${total} décaissement(s)`
                        }}
                        style={{ fontSize: "13px" }}
                        rowClassName={(record, index) => {
                            return index % 2 === 0 ? "even-row" : "odd-row";
                        }}
                    />
                    <style>{`
            .even-row { background-color: #ffffff !important; }
            .odd-row { background-color: #f9fafb !important; }
            .ant-table tbody > tr:hover > td { background-color: #f3f4f6 !important; }
          `}</style>
                </Card>
            ) : (
                <Card
                    style={{
                        borderRadius: "12px",
                        border: "2px dashed #d1d5db",
                        textAlign: "center",
                        padding: "60px 20px",
                        background: "#ffffff"
                    }}
                >
                    <DollarOutlined style={{ fontSize: "64px", color: "#d1d5db", marginBottom: "16px" }} />
                    <h3 style={{ fontSize: "18px", fontWeight: 600, color: "#4b5563", margin: "0 0 8px 0" }}>
                        Aucun règlement effectué
                    </h3>
                    <p style={{ color: "#6b7280", margin: 0 }}>
                        Aucun décaissement n'a encore été enregistré pour ce dossier sinistre
                    </p>
                </Card>
            )}
            <Modal
                title={`QUITTANCE D'INDEMNITE - SINISTRE N° ${sinistre?.numSinistre}`}
                centered
                open={modalQuittance}
                onOk={() => setModalQuittance(false)}
                onCancel={() => setModalQuittance(false)}
                width={850}
            >
                <div id="quittanceSinistre" ref={printQReference}>
                    <QuittanceIndemnite decaissement={quittance} sinistre={sinistre} />
                </div>
                <AntdButton
                    onClick={exportQToPdf}
                    type="primary"
                    style={{ background: "blue" }}
                    icon={<PrinterOutlined />}
                >
                    Imprimer
                    <br />
                    <br />
                    <br />
                </AntdButton>
            </Modal>

            <Modal
                title={`FICHE DE DEMANDE DE REGLEMENT - SINISTRE N° ${sinistre?.numSinistre}`}
                centered
                open={modalFicheDemandeReglement}
                onOk={() => setModalFicheDemandeReglement(false)}
                onCancel={() => setModalFicheDemandeReglement(false)}
                width={850}
            >
                <div id="ficheDemandeReglement" ref={printFDReference}>
                    <FicheDemandeReglementSinistre
                        decaissement={ficheDemandeReglement}
                        sinistre={sinistre}
                    />
                </div>
                <Button
                    onClick={exportFDRToPdf}
                    type="primary"
                    style={{ background: "gray" }}
                    icon={<PrinterOutlined />}
                >
                    Imprimer
                    <br />
                    <br />
                    <br />
                </Button>
            </Modal>

            <Modal
                title={`ORDRE DE DÉPENSE - SINISTRE N° ${sinistre?.numSinistre || sinistre?.numeroSinistrem || sinistre?.numeroSinistreM}`}
                centered
                open={modalOrdreDepense}
                onOk={() => setModalOrdreDepense(false)}
                onCancel={() => setModalOrdreDepense(false)}
                width={850}
            >
                <div id="ordreDepense" ref={printODReference}>
                    <OrdreDeDepense decaissement={ordreDepense} sinistre={sinistre} />
                </div>
                <Button
                    onClick={exportODToPdf}
                    type="primary"
                    style={{ background: "blue" }}
                    icon={<PrinterOutlined />}
                >
                    Imprimer
                    <br />
                    <br />
                    <br />
                </Button>
            </Modal>

            <AssignCheque
                open={modalAssignCheque}
                decaissement={decaissement}
                sinistre={sinistre}
                onCancel={() => setModalAssignCheque(false)}
            />
            <RemiseCheque
                open={modalRemiseCheque}
                decaissement={decaissement}
                sinistre={sinistre}
                onCancel={() => setModalRemiseCheque(false)}
            />
            <AnnulerCheque
                open={modalAnnulerCheque}
                decaissement={decaissement}
                sinistre={sinistre}
                onCancel={() => setModalAnnulerCheque(false)}
            />
            <ReglementModal
                sinistre={sinistre}
                modalControl={reglementControl}
                sap={sinistre?.sap}
                sapMin={1000}
            />
            <EditDecaissementModal
                codeId={editDecaissementId}
                open={editModalOpen}
                onClose={handleEditModalClose}
                onUpdated={handleDecaissementUpdated}
            />
        </div>
    );
};

export default ReglementsTab;
